import React from "react";
import { Carousel, Card } from "../ui/apple-cards-caraousel";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export function ServiceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ));

  return (
    <div id="service-college-section" className="w-full h-full py-20" ref={ref}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-center "
      >
        <h2 className="text-4xl text-center lg:text-5xl font-bold mb-4">
          <span className="bg-text-gradient bg-clip-text text-transparent">
            Services We Provide
          </span>
        </h2>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Choose What Works for Your Students
        </p>
      </motion.div>
      <Carousel items={cards} />
    </div>
  );
}

// const DummyContent = () => {
//   return (
//     <>
//       {[...new Array(3).fill(1)].map((_, index) => {
//         return (
//           <div
//             key={"dummy-content" + index}
//             className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl mb-4"
//           >
//             <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
//               <span className="font-bold text-neutral-700 dark:text-neutral-200">
//                 The first rule of Apple club is that you boast about Apple club.
//               </span>{" "}
//               Keep a journal, quickly jot down a grocery list, and take amazing
//               class notes. Want to convert those notes to text? No problem.
//               Langotiya jeetu ka mara hua yaar is ready to capture every
//               thought.
//             </p>
//             <img
//               src="https://assets.aceternity.com/macbook.png"
//               alt="Macbook mockup from Aceternity UI"
//               height="500"
//               width="500"
//               className="md:w-1/2 md:h-1/2 h-full w-full mx-auto object-contain"
//             />
//           </div>
//         );
//       })}
//     </>
//   );
// };

const data = [
  {
    category: "Group Sessions",
    title: "Combined Group Sessions",
    src: "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_GroupDiscussion_12.jpg",
    // content: <DummyContent />,
  },
  {
    category: "Resume Building",
    title: "Resume Vetting (1:1)",
    src: "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_Resume_4.jpg",

    // content: <DummyContent />,
  },
  {
    category: "Group",
    title: "Mock Group Discussion (GD)",
    src: "https://d1x6q4m9kni4a2.cloudfront.net/public/collegeService_MockDiscussion_8.jpg",
    // content: <DummyContent />,
  },

  //   {
  //     category: "iOS",
  //     title: "Photography just got better.",
  //     src: "https://images.unsplash.com/photo-1602081957921-9137a5d6eaee?q=80&w=2793&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     // content: <DummyContent />,
  //   },
  //   {
  //     category: "Hiring",
  //     title: "Hiring for a Staff Software Engineer",
  //     src: "https://images.unsplash.com/photo-1511984804822-e16ba72f5848?q=80&w=2048&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     // content: <DummyContent />,
  //   },
];
